<template>
	<v-container fluid="fluid">
		<v-layout row wrap>
			<h1 class="hidden-sm-and-down">Dashboard</h1>
			<v-spacer class="hidden-sm-and-down"></v-spacer>
			<v-select
				v-model="selectedYear"
				prepend-inner-icon="date_range"
				:items="years"
				label="Jaartal"
				@change="selectYear($event)"
			></v-select>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 md6 xl6 chartContainer px-1 py-2>
				<h2>Totale omzet {{ selectedYear }}</h2>
				&euro; {{ total_revenue | toCurrency }}
				<v-menu bottom left>
					<v-btn icon slot="activator" light>
						<v-icon>more_vert</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile
							v-for="(item, i) in ['Hele jaar'].concat(
								utils.getMonths(this.currentYear === this.selectedYear)
							)"
							:key="i"
							@click="setStatsFilter(i, 'revenue')"
						>
							<v-list-tile-title>{{ item }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>

				<v-card class="wide" color :class="zoom1 ? 'expanded' : ''">
					<div id="chart"></div>
				</v-card>
			</v-flex>
			<v-flex xs12 md6 xl6 chartContainer py-2>
				<h2>Totale afstand {{ selectedYear }}</h2>
				{{ total_km }} Km
				<v-menu bottom left>
					<v-btn icon slot="activator" light>
						<v-icon>more_vert</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile
							v-for="(item, i) in ['Hele jaar'].concat(
								utils.getMonths(this.currentYear === this.selectedYear)
							)"
							:key="i"
							@click="setStatsFilter(i, 'km')"
						>
							<v-list-tile-title>{{ item }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
				<v-card class="wide" color :class="zoom2 ? 'expanded' : ''">
					<div id="chart_distance"></div>
				</v-card>
			</v-flex>
			<v-flex xs12 md6 xl6 chartContainer px-1 py-2 mt-3>
				<h2 class="mb-4">Weekverdeling</h2>

				<v-card class="pt-2">
					<div id="chart_week"></div>
				</v-card>
			</v-flex>
			<v-flex xs12 md6 xl6 chartContainer px-0 py-2 mt-3>
				<h2 class="mb-4">Jaarverdeling</h2>

				<v-card class="pt-2">
					<div id="chart_days"></div>
				</v-card>
			</v-flex>
			<v-flex xs12 md6 xl6 chartContainer py-2 mt-3>
				<h2 class="mb-4">BTW bedrag</h2>
				<v-menu bottom left>
					<v-btn icon slot="activator" light>
						<v-icon>more_vert</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile
							v-for="(item, i) in ['Hele jaar'].concat(
								utils.getMonths(this.currentYear === this.selectedYear)
							)"
							:key="i"
							@click="setStatsFilter(i, 'vat')"
						>
							<v-list-tile-title>{{ item }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
				<br />
				&euro; {{ monthly_vat | toCurrency }}
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import * as utils from '@/utils/utils';
import { _ } from 'vue-underscore';
import ApexCharts from 'apexcharts';
import moment from 'moment';
// Show loader
export default {
	name: 'Dashboard',
	data: function() {
		return {
			utils: utils,
			total_revenue: '',
			total_km: '',
			monthly_vat: '',
			revenueMonth: '',
			charts: {},
			zoom1: false,
			zoom2: false,
			zooms: [false],
			themeLight: true,
			currentYear: 2019,
			selectedYear: 2019,
			statsFilter: {
				revenue: '',
				km: '',
				vat: ''
			},
			charts: {},
			barColor: '#66BB6A',
			lineColor: '#0277BD'
		};
	},
	created: function() {
		let self = this;
		if (localStorage.getItem('theme')) {
			self.themeLight = localStorage.getItem('theme') === 'light';
		}
		setTimeout(function() {
			self.getStats(false);
		}, 300);
		let currentDate = new Date();
		this.currentYear = currentDate.getFullYear();
		this.selectedYear = currentDate.getFullYear();
	},
	computed: {
		years() {
			const today = new Date();
			return [
				today.getFullYear(),
				today.getFullYear() - 1,
				today.getFullYear() - 2
			];
		}
	},
	methods: {
		selectYear(year) {
			this.selectedYear = year;
			this.getStats(true);
		},
		setStatsFilter(value, key) {
			if (value === 0) {
				this.statsFilter[key] = '';
			} else {
				this.statsFilter[key] = value;
			}

			// Get stats
			this.getStats(true);
		},
		getStats: function(update) {
			var self = this;
			utils
				.setData(
					basePath + 'api/dashboard/getRevenue/' + this.selectedYear,
					this.statsFilter
				)
				.then(function(response) {
					if (response) {
						var revenue = _.pluck(response.unitsRevenue, 'totalRevenue');
						var distance = _.pluck(response.unitsDistance, 'totalDistance');
						var unitsRevenueFullLabels = _.pluck(
							response.unitsRevenue,
							'fullname'
						);
						var unitsRevenue = _.pluck(response.unitsRevenue, 'name');
						var unitsDistance = _.pluck(response.unitsDistance, 'name');
						var unitsDistanceFullLabels = _.pluck(
							response.unitsDistance,
							'fullname'
						);
						self.total_revenue = parseFloat(response.all.revenue).toFixed(2);
						self.total_km = parseFloat(response.all.km).toFixed(2);
						self.monthly_vat = response.all.vat;
						self.initCharts(
							'chart',
							revenue,
							unitsRevenueFullLabels,
							'Omzet',
							update,
							'#01579B'
						);
						self.initCharts(
							'chart_distance',
							distance,
							unitsDistanceFullLabels,
							'Afstand',
							update,
							'#1B5E20'
						);
						self.initLineChart(
							'chart_week',
							response.weekDistribution,
							['Ma', 'Di', 'Woe', 'Do', 'Vr', 'Za', 'Zo'],
							'Aantal keer verhuurd',
							'Dagen',
							self.lineColor
						);

						let monthsValues = _.values(response.dayDistribution);
						let months = [
							'Jan',
							'Feb',
							'Mrt',
							'Apr',
							'Mei',
							'Jun',
							'Jul',
							'Aug',
							'Sept',
							'Okt',
							'Nov',
							'Dec'
						];
						let monthLabels = [];
						Object.keys(response.dayDistribution).forEach(function(key) {
							monthLabels.push(months[parseInt(key) - 1]);
						});

						self.initLineChart(
							'chart_days',
							monthsValues,
							monthLabels,
							'Aantal keer verhuurd',
							'Verhuurdagen',
							'#D84315'
						);
					}
				});
		},
		initCharts(element, data, labels, title, update, barColor) {
			let parsedData = [];
			for (var i = 0; i < data.length; i++) {
				parsedData.push(parseFloat(data[i]));
			}

			if (!update) {
				var options = {
					chart: {
						type: 'bar',
						height: 400
					},
					colors: [barColor],
					series: [
						{
							name: title,
							data: parsedData
						}
					],
					xaxis: {
						categories: labels,
						labels: {
							rotate: 90,
							formatter: function(i) {
								let label = i.split(' ');
								return label[1];
							}
						}
					},
					dataLabels: {
						enabled: false
					},
					tooltip: {
						theme: this.themeLight ? 'light' : 'dark',
						x: {
							show: true,
							formatter: function(i) {
								return i;
							}
						}
					}
				};
				this.charts[title] = new ApexCharts(
					document.querySelector('#' + element),
					options
				);
				this.charts[title].render();
			} else {
				this.charts[title].updateSeries([
					{
						data: parsedData
					}
				]);
			}
		},
		initLineChart(element, data, labels, title, indicatorText, lineColor) {
			let parsedData = [];
			for (var i = 0; i < data.length; i++) {
				parsedData.push(parseFloat(data[i]));
			}

			var options = {
				chart: {
					height: 380,
					type: 'area',
					zoom: {
						enabled: false
					}
				},
				colors: [lineColor],
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: 'smooth'
				},
				series: [
					{
						name: indicatorText,
						data: parsedData
					}
				],
				title: {
					text: title,
					align: 'left'
				},
				grid: {
					row: {
						colors: ['#EEE', 'transparent'], // takes an array which will be repeated on columns
						opacity: 0.15
					}
				},
				xaxis: {
					categories: labels,
					labels: {
						textAnchor: 'start'
					}
				}
			};

			var chart = new ApexCharts(
				document.querySelector('#' + element),
				options
			);

			chart.render();
		}
	}
};
</script>
<style lang="scss">
.application.theme--light {
	.chartContainer {
		.v-card {
			background-color: #fff;
			box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
		}
	}
}
.application.theme--dark {
	.chartContainer {
		color: #fff !important;
		.apexcharts-xaxis-label,
		.apexcharts-yaxis-label,
		.apexcharts-title-text {
			fill: #fff !important;
		}
	}
}
.chartContainer {
	overflow-x: hidden;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	.v-card.wide {
		max-width: 2500px;
		//  min-width: 1000px;
		min-height: 300px;

		&.expanded {
			min-width: 1000px;
		}
	}
}

@media only screen and (max-width: 700px) {
	.zoombtn {
		display: inline-block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue